import React from "react";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { CaptureProvider } from "../../../../contexts/capture";
import { useKitAssets } from "../../../../contexts/kit-assets";
import { useKitsCollection } from "../../../../contexts/kitsCollection";
import FormPageKitting from "../../../../components/TablePro/components/assets/FormPageKitting";

export const fetchKitValues = asset => {
  if (!asset?.id) return {};

  return {
    manufacturer: asset.manufacturer || "",
    barcode: asset.barcode || "",
    description: asset.description || "",
    descriptionComments: asset.descriptionComments || "",
    color: asset.color || "",
    model: asset.model || "",
    groupBySkuNumber: asset.groupBySkuNumber || false,
    dimensions: asset.dimensions,
  };
};

export default function KitDetailsModal({ disabled, entity: item, onClose, projectId }) {
  const { collection } = useKitsCollection();
  const { kit, loading: loadingKit } = useKitAssets();
  const entity = kit?.id ? kit : collection.find(v => v.id === item.id);

  return (
    <CaptureProvider>
      <Formik
        key={entity?.id}
        enableReinitialize
        initialValues={fetchKitValues(entity)}
        onSubmit={() => {}}
      >
        <form
          id="assetForm"
          className="d-flex flex-column flex-grow-1 justify-content-between justify-content-md-start"
          style={{ position: "relative" }}
        >
          <Dialog open fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle
              sx={{ background: "#f4f6f8", display: "flex", justifyContent: "space-between" }}
            >
              <Box width="48px" />
              <Typography fontSize={24} fontWeight={500} color="textPrimary">
                Kit Details
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <FormPageKitting
              disabled={disabled}
              type="scrubber"
              projectId={projectId}
              currentAsset={entity}
              isAssetLoading={loadingKit && !entity?.id}
              onCloseModal={onClose}
            />
          </Dialog>
        </form>
      </Formik>
    </CaptureProvider>
  );
}
